export default (paymentValidUntil: string | null | undefined): boolean => {
  // If there's no validUntil date, payment is always due
  if (paymentValidUntil === null || paymentValidUntil === undefined) {
    return true
  }

  // Parse the validUntil date
  const validUntilDate = new Date(paymentValidUntil)
  if (validUntilDate.toString() === "Invalid Date") {
    return true
  }

  // Create "expired" date (November 1st of the same year as validUntil)
  const expiredFromDate = new Date(Date.UTC(
    validUntilDate.getUTCFullYear(),
    10, // November (0-indexed)
    1  // 1st day
  ))

  // Compare with current date in UTC
  // For testing use:
  // const currentDate = new Date(Date.UTC(2025, 10, 1))
  const currentDate = new Date()
  const currentDateUTC = new Date(Date.UTC(
    currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(),
    currentDate.getUTCDate()
  ))

  // Return true if current date is at or after the "expired" date
  return currentDateUTC >= expiredFromDate
}
